
<div class="content-wrapper">
  <lib-error-not-found [homepageRoute]="homepageRoute"></lib-error-not-found>
</div>